// @flow

import React from 'react'
import { WizardPageOption } from '@chatchamp/chatchamp-types'

import './SingleChoiceOptionPreview.scss'

type Props = {
  option: WizardPageOption,
  isMultiple?: boolean
}

export function SingleChoiceOptionPreview ({ option, isMultiple }: Props) {
  return (
    <div className="single-choice-option-preview">
      {option.imageUrl && (
        <img className="single-choice-option-preview__image" src={option.imageUrl} />
      )}
      <div className="single-choice-option-preview__title">
        {option.title}
      </div>
      {(option.infoText?.title || option.infoText?.description) && (
        <div className="single-choice-option-preview__icon-info">
          <i className="fa-regular fa-info" />
        </div>
      )}
      {isMultiple && (
        <div className="single-choice-option-preview__checkbox">
          <i className="fa-regular fa-check single-choice-option-preview__checkbox__icon" />
        </div>
      )}
    </div>
  )
}
